let globalMMTimeout = 0

class PvtMegamenuItem extends HTMLElement {
  constructor() {
    super()
    this.$detail = this.querySelector('details')
    this.$trigger = this.$detail.querySelector('summary')
    this.$dropdown = this.$detail.querySelector(
      '.pivot-megamenu-item__dropdown'
    )
    this.$aside = this.querySelector('.pivot-megamenu-item__main-aside ul')
    this.$subItemsWrapper = this.querySelector('.pivot-megamenu-item__subitems')
    this.$parent = this.closest('.shopify-section')
    this.openMode = this.dataset.openMode
    this.sidemenuBehavior = this.dataset.sidemenuBehavior
    this.isTouch = window.matchMedia('(hover:none)')
    this.hideDebounce = 0

    // Cerrar el menu al esconder el header
    const observer = new MutationObserver(entries => {
      entries.forEach(entry => {
        if (!this.$detail.open) return
        const clss = this.$parent.getAttribute('class')
        if (clss === entry.oldValue) return
        this.$detail.open = !this.$parent.classList.contains(
          'shopify-section-header-hidden'
        )
      })
    })
    observer.observe(this.$parent, {
      attributeFilter: ['class'],
      attributes: true,
      attributeOldValue: true,
    })

    // Cerrar al clickear fuera
    this.$dropdown.addEventListener(
      'mouseleave',
      e => {
        if (e.target === this.$dropdown) {
          this.$detail.open = false
        }
      },
      false
    )

    // Hover en los elementos internos
    const openMenu = e => {
      e.preventDefault()
      clearTimeout(globalMMTimeout)
      globalMMTimeout = setTimeout(() => {
        // Ítems como "Marcas" no tienen aside (usan un layout de carrusel),
        // así que este handler no aplica ahí.
        if (!this.$aside || !this.$subItemsWrapper) return

        const $newMenuActive = this.$aside.querySelector(
          '.pivot-megamenu-item__main-aside-link:hover'
        )
        if (!$newMenuActive) return

        const $currentMenuActive = this.$aside.querySelector('.active')
        const $currentGridActive =
          this.$subItemsWrapper.querySelector('.active')

        if ($currentMenuActive) $currentMenuActive.classList.remove('active')
        if ($currentGridActive) $currentGridActive.classList.remove('active')

        $newMenuActive.classList.add('active')
        this.$subItemsWrapper
          .querySelector(`#${$newMenuActive.dataset.item}`)
          ?.classList.add('active')
      }, 70)
    }
    // Sin esto, $aside es null para ítems sin aside (ej: "Marcas") y
    // addEventListener rompe el constructor antes de llegar al listener
    // de "mouseover" del trigger, que es el que abre el menú al hacer hover.
    if (this.$aside) {
      this.$aside.addEventListener(
        this.sidemenuBehavior === 'navigate' && !this.isTouch.matches
          ? 'mouseover'
          : 'click',
        openMenu
      )
    }

    if (this.$subItemsWrapper) {
      this.$subItemsWrapper.addEventListener('mouseover', () =>
        clearTimeout(globalMMTimeout)
      )
    }
    // Hover en el trigger
    if (this.openMode === 'hover')
      this.$trigger.addEventListener('mouseover', () => {
        this.$detail.open = true
      })

    // Ocultar al salir del trigger
    this.$trigger.addEventListener('mouseleave', e => {
      this.hideDebounce = setTimeout(() => {
        this.$detail.open = false
      }, 250)
    })
    this.$dropdown.addEventListener('mouseover', () => {
      if (this.hideDebounce) clearTimeout(this.hideDebounce)
    })
  }
}
if (!customElements.get('pvt-megamenu-item')) {
  customElements.define('pvt-megamenu-item', PvtMegamenuItem)

  // Abrir/cerrar otros elementos del megamenú
  const stickyHeader = document.querySelector('sticky-header')
  const summaries = document.querySelectorAll(
    'sticky-header .list-menu--inline > li > header-menu > details, sticky-header .list-menu--inline > li > pvt-megamenu-item > details'
  )

  const openObserver = new MutationObserver(entries =>
    entries.forEach(entry => {
      const parentName = entry.target.parentElement.tagName.toLowerCase()
      if (
        !entry.target.open ||
        (parentName != 'header-menu' && parentName != 'pvt-megamenu-item')
      )
        return
      summaries.forEach(el => {
        if (el !== entry.target) el.open = false
      })
    })
  )

  // Subscribir todos los summaries
  openObserver.observe(stickyHeader, {
    attributes: true,
    attributeFilter: ['open'],
    subtree: true,
  })
}